import { FormInput, FormTextarea, RHF } from "@/shared/forms";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Switch } from "@/components/ui/switch";
import { TruckIcon } from "lucide-react";
import type { UseFormReturn } from "react-hook-form";

export type SupplierFormValues = {
  name: string;
  code: string;
  contactName: string;
  phone: string;
  email: string;
  address: string;
  taxId: string;
  paymentTerms: string;
  notes: string;
  isActive: boolean;
};

type SupplierFormCardProps = {
  form: UseFormReturn<SupplierFormValues>;
};

export function SupplierFormCard({ form }: SupplierFormCardProps) {
  return (
    <Card className="rounded-xl border bg-card">
      <CardHeader className="pb-4">
        <CardTitle className="flex items-center gap-2 font-heading text-lg">
          <TruckIcon className="size-5 text-muted-foreground" />
          ຂໍ້ມູນຜູ້ສະໜອງ
        </CardTitle>
        <p className="text-muted-foreground text-sm">
          ຊື່ (ບັງຄັບ) · ລະຫັດ · ການຕິດຕໍ່ · ເງື່ອນໄຂການຊຳລະ
        </p>
      </CardHeader>
      <CardContent className="space-y-6">
        <div className="grid gap-4 sm:grid-cols-2">
          <FormInput
            name="name"
            label="ຊື່ຜູ້ສະໜອງ"
            placeholder="ຕົວຢ່າງ: ບໍລິສັດ ABC"
            requiredMark
          />
          <FormInput
            name="code"
            label="ລະຫັດ (ທາງເລືອກ)"
            placeholder="SUP-001"
          />
        </div>
        <div className="grid gap-4 sm:grid-cols-2">
          <FormInput name="contactName" label="ຊື່ຜູ້ຕິດຕໍ່" />
          <FormInput name="phone" label="ເບີໂທ" />
          <FormInput name="email" label="ອີເມວ" type="email" />
          <FormInput name="taxId" label="ເລກປະຈຳຕົວຜູ້ເສຍພາສີ" />
        </div>
        <FormTextarea name="address" label="ທີ່ຢູ່" rows={2} />
        <FormInput
          name="paymentTerms"
          label="ເງື່ອນໄຂຊຳລະ"
          placeholder="NET30"
        />
        <FormTextarea name="notes" label="ໝາຍເຫດ" rows={3} />
        <div className="flex items-center justify-between rounded-[12px] border bg-muted/30 p-4">
          <div>
            <p className="font-medium text-sm">ເປີດໃຊ້</p>
            <p className="text-muted-foreground text-xs">
              ຜູ້ສະໜອງປິດຈະບໍ່ເລືອກໃນ PO ໃໝ່
            </p>
          </div>
          <RHF.Controller
            name="isActive"
            control={form.control}
            render={({ field }) => (
              <Switch checked={field.value} onCheckedChange={field.onChange} />
            )}
          />
        </div>
      </CardContent>
    </Card>
  );
}
